import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-dynamic-popup',
  templateUrl: './dynamic-popup.component.html',
  styleUrls: ['./dynamic-popup.component.scss'],
  standalone: true,
  imports: [SvgIconComponent],
})
export class DynamicPopupComponent {
  @Input() visible = false;
  @Input() title = '';
  @Input() description = '';
  @Input() primaryText = '';
  @Input() secondaryText = '';
  @Input() tertiaryText = '';

  @Output() popupClose = new EventEmitter<void>();
  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
  @Output() tertiaryAction = new EventEmitter<void>();

  onClose() {
    this.visible = false;
    this.popupClose.emit();
  }

  onPrimaryClick() {
    this.primaryAction.emit();
  }

  onSecondaryClick() {
    this.secondaryAction.emit();
  }

  onTertiaryClick() {
    this.tertiaryAction.emit();
  }
}
